import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';
import {  accessLocalStorage, clickToCall, cancelClickToCall, trasferCall, cancelTrasferCall, clickToSpy } from '../../services';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPhoneAlt, faShare, faStopCircle, faPhoneSlash, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import './EndpointCard.css';

const EndpointCard = (props) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { channelInState, clickToCallChannel, activeCallsByEndpoint } = getItensStateGlobal;
  const [buttonClick2Call, setButtonClick2Call] = useState(false);
  const [buttonTransferCall, setButtonTransferCall] = useState(false);
  const [channelTransferOn, setChannelTransferOn] = useState('');
  const [showOffLine, setShowOffLine] = useState(true);
  const [showActions, setShowActions] = useState(false);

  const { endpoint, show, canViewRegistration, onOpenRegistration } = props;
  const { resource, state, name } = endpoint;
  let { channel_ids, myClass } = props.endpoint;
  let fontColorChanged = '';
  const ipDB = localStorage.getItem(endpoint.resource);
  const endpointReceived = JSON.parse(ipDB);
  let iconsClass = '';
  let ipDbReceived = 'IP não localizado';
  let statusClass = 'offline';
  let statusText = '---';
  const activeCall = activeCallsByEndpoint ? activeCallsByEndpoint[resource] : null;
  const remoteNumber = activeCall ? activeCall.remoteNumber : null;

  if(ipDB !== null) ipDbReceived = endpointReceived.ip;

  if(channel_ids.length < 1 && state === 'online') {
    channel_ids = 'livre';
    statusClass = 'online';
    statusText = 'Livre';
    iconsClass = 'icons-endpoints';
    myClass = 'has-background-success';
  } else if (channel_ids.length > 0 && state === 'online') {
      channel_ids = 'ocupado';
      statusClass = 'busy';
      statusText = 'Ocupado';
      iconsClass = 'icons-endpoints';
      myClass = 'has-background-danger-dark';
      fontColorChanged = 'has-text-white';
  } else {
    channel_ids = '---';
    statusClass = 'offline';
    statusText = 'Offline';
    ipDbReceived = '';
    myClass = show ? 'has-background-light' : 'is-hidden';
  }

  const handleClick = async (dest, name) => {
    if (!name) name = dest;
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const myEndpoint = { 
      name,
      dest,
      "exten": user.endpoint,
    }
    const result = await clickToCall(myEndpoint);
    if (result.status === 200) setButtonClick2Call(true);
  };

  const handleClickStop = async () => {
    const myEndpoint = {
      channel: clickToCallChannel,
    }
    const result = await cancelClickToCall(myEndpoint);
    if (result.status === 200) setButtonClick2Call(false);
  };

  const handleTransfer = async (dest) => {
    const { user: { endpoint } } = await accessLocalStorage.getUserLocalStorage();
    const { channelId, endpointNumber } = channelInState;

    if (endpoint !== endpointNumber) return;

    const myEndpoint = {
      channel: channelId,
      dest,
    }
    const result = await trasferCall(myEndpoint);
    setChannelTransferOn(channelId);
    if (result.status === 200) setButtonTransferCall(true);
  };

  const handleTransferStop = async (dest) => {
    const myEndpoint = {
      channel: channelTransferOn,
      dest,
    }
    const result = await cancelTrasferCall(myEndpoint);
    if (result.status === 200) setButtonTransferCall(false);
  };

  const handleClickSpy = async (dest) => {
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const data = {
      dest,
      "exten": user.endpoint,
    };
    return await clickToSpy(data);
  };
  
  const toggleActions = () => {
    if (state === 'offline') return;
    setShowActions(!showActions);
  };

  const openRegistration = (event) => {
    event.stopPropagation();
    onOpenRegistration(resource);
  };

  if (myClass === 'is-hidden') return null;

  return (
    <div className={`endpoint-card-wrapper ${statusClass}`}>
      <div className="endpoint-card" onClick={toggleActions}>
        <div className="endpoint-status-indicator"></div>
        
        {!showActions ? (
          <div className="endpoint-info">
            <div className="endpoint-label">Ramal</div>
            <div className="endpoint-number">{name}</div>
            <div className={`endpoint-status ${statusClass}`}>
              <span className="status-dot"></span>
              {statusText}
            </div>
            {statusClass === 'busy' && remoteNumber && (
              <div className="endpoint-remote-number">{remoteNumber}</div>
            )}
            {canViewRegistration && (
              <button
                type="button"
                onClick={openRegistration}
                className="endpoint-registration-btn"
                title="Registro"
                aria-label={`Registro do ramal ${name}`}
              >
                <FontAwesomeIcon icon={faInfoCircle} />
              </button>
            )}
          </div>
        ) : (
          <div className="endpoint-actions">
            <button 
              onClick={(e) => { e.stopPropagation(); handleClick(resource); }} 
              hidden={buttonClick2Call}
              className="action-btn success"
              title="Ligar"
            >
              <FontAwesomeIcon icon={faPhoneAlt} />
            </button>
            <button 
              onClick={(e) => { e.stopPropagation(); handleClickStop(); }} 
              hidden={!buttonClick2Call}
              className="action-btn danger"
              title="Desligar"
            >
              <FontAwesomeIcon icon={faPhoneSlash} />
            </button>
            <button 
              onClick={(e) => { e.stopPropagation(); handleTransfer(resource); }} 
              hidden={buttonTransferCall}
              className="action-btn info"
              title="Transferir"
            >
              <FontAwesomeIcon icon={faShare} />
            </button>
            <button 
              onClick={(e) => { e.stopPropagation(); handleTransferStop(resource); }} 
              hidden={!buttonTransferCall}
              className="action-btn danger"
              title="Cancelar Transferência"
            >
              <FontAwesomeIcon icon={faStopCircle} />
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); handleClickSpy(resource); }}
              className="action-btn warning"
              title="Espionar"
              disabled={statusClass !== 'busy'}
            >
              <FontAwesomeIcon icon={faEye} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EndpointCard;
